import styled from 'styled-components';
import { BreakpointRange, getSpacingToken, getTextTokenPresetObject, getToken, mediaMinWidth } from '@optimus-web/core';
import { SecureIcon } from './secureIcon';

export const CardTypeListContainer = styled.div`
    margin-top: ${getSpacingToken('100')}px;

    ${mediaMinWidth(BreakpointRange.Desktop)} {
        margin-top: 0px;
    }
`;

export const LockIcon = styled(SecureIcon)`
    display: block;
    flex-shrink: 0;
    margin-right: ${getSpacingToken('100')}px;
    width: 30px;
`;

export const LockIconContainer = styled.div`
    align-items: center;
    display: flex;
    flex-flow: row;
    flex-wrap: nowrap;

    ${mediaMinWidth(BreakpointRange.Desktop)} {
        height: 45px;
        margin-right: ${getSpacingToken('200')}px;
        margin-bottom: 0;
    }
`;

export const Container = styled.div`
    align-items: center;
    background-color: ${getToken('backgroundInteractiveNeutralSubtleActive')};
    display: flex;
    flex-direction: column;
    padding: ${getSpacingToken('200')}px;
    border-radius: ${getToken('borderRadius50')}px;

    ${mediaMinWidth(BreakpointRange.Desktop)} {
        flex-direction: row;
        justify-content: center;
    }
`;

export const SecuredContainer = styled.div`
    font-size: ${(props) => getTextTokenPresetObject('bodyMedium')({ theme: props.theme }).fontSize};
    line-height: ${(props) => getTextTokenPresetObject('bodySmall')({ theme: props.theme }).lineHeight};

    ${mediaMinWidth(BreakpointRange.Desktop)} {
        font-size: ${(props) => getTextTokenPresetObject('bodyLarge')({ theme: props.theme }).fontSize};
    }
`;

export const PaymentGateTitle = styled.span`
    font-weight: ${(props) => getTextTokenPresetObject('titleMediumStrong')({ theme: props.theme }).fontWeight};
`;
